module.exports = require('./helpers/bundle-url').getBundleURL('fI1AJ') + "logo.c51670a8.svg";